module.exports = __webpack_public_path__ + "img/icon_jadwal_jam_kerja.c3fb8f04.svg";